import React from 'react';
import { remCss, scssVariables as variables } from 'src/helpers';

const RadiotherapyIcon = React.memo(({ width = 81, height = 80, viewBox = '0 0 81 80' }) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width={remCss(width)}
    height={remCss(height)}
    viewBox={viewBox}
  >
    <path
      fill={variables['colors-mc-primary']}
      fillOpacity='0.1'
      stroke={variables['colors-mc-primary']}
      d='M79.6426 40C79.6426 61.8153 61.9578 79.5 40.1426 79.5C18.3273 79.5 0.642578 61.8153 0.642578 40C0.642578 18.1848 18.3273 0.5 40.1426 0.5C61.9578 0.5 79.6426 18.1848 79.6426 40Z'
    />
    <g clipPath='url(#clip0_414_9323)'>
      <path
        d='M59.0362 49.7241H40.5801V46.5562H57.0019C58.1254 46.5562 59.0361 47.467 59.0361 48.5904L59.0362 49.7241Z'
        fill='#78D0B1'
      />
      <path
        d='M57.0019 46.5562H54.7256C55.8491 46.5562 56.7599 47.467 56.7599 48.5905V49.7242H59.0361V48.5905C59.0362 47.467 58.1254 46.5562 57.0019 46.5562Z'
        fill='#61AAB7'
      />
      <path
        d='M39.023 50.0559C40.646 50.0559 41.9616 48.7402 41.9616 47.1173C41.9616 45.4944 40.646 44.1787 39.023 44.1787C37.4001 44.1787 36.0845 45.4944 36.0845 47.1173C36.0845 48.7402 37.4001 50.0559 39.023 50.0559Z'
        fill='#F1B986'
      />
      <path
        d='M39.0232 44.1787C38.7523 44.1787 38.4903 44.2161 38.2412 44.2848C39.4844 44.6272 40.3978 45.7653 40.3978 47.1174C40.3978 48.4694 39.4844 49.6074 38.2412 49.9499C38.4903 50.0186 38.7523 50.056 39.0232 50.056C40.6462 50.056 41.9618 48.7403 41.9618 47.1174C41.9618 45.4943 40.6462 44.1787 39.0232 44.1787Z'
        fill='#E2A770'
      />
      <path
        d='M37.6673 49.7241H35.1372V44.7178C35.1372 43.9834 35.7325 43.3882 36.4668 43.3882H37.3256C37.5143 43.3882 37.6673 43.5411 37.6673 43.7299V49.7241Z'
        fill='#2B4D66'
      />
      <path d='M30.0371 53.127H59.9778V63.9012H30.0371V53.127Z' fill='#98B9D3' />
      <path
        d='M30.0371 53.127V54.7481H55.2063C56.811 54.7481 58.1119 56.049 58.1119 57.6537V63.9013H59.9779V53.127H30.0371Z'
        fill='#81A7C6'
      />
      <path
        d='M61.3456 49.3335H30.0371V53.127H61.3456C62.3932 53.127 63.2423 52.2777 63.2423 51.2303C63.2424 50.1827 62.3932 49.3335 61.3456 49.3335Z'
        fill='#E4F6FF'
      />
      <path
        d='M61.3454 49.3335H59.3037C60.3513 49.3335 61.2004 50.1827 61.2004 51.2302C61.2004 52.2776 60.3512 53.1269 59.3037 53.1269H61.3455C62.3931 53.1269 63.2422 52.2776 63.2422 51.2302C63.2422 50.1827 62.393 49.3335 61.3454 49.3335Z'
        fill='#BED8FB'
      />
      <path
        d='M18.2964 17.5994V63.9014H34.5203L30.8587 29.7369C30.728 28.5175 31.6836 27.454 32.9101 27.454H57.7444C58.9778 27.454 59.9776 26.4542 59.9776 25.2208V17.5994C59.9776 16.366 58.9778 15.3662 57.7444 15.3662H20.5296C19.2963 15.3662 18.2964 16.366 18.2964 17.5994Z'
        fill='#F1F1F4'
      />
      <path
        d='M32.9101 27.4539H30.5272C29.3008 27.4539 28.3452 28.5173 28.4758 29.7368L32.1375 63.9012H34.5204L30.8587 29.7368C30.7281 28.5174 31.6837 27.4539 32.9101 27.4539Z'
        fill='#DFEAEF'
      />
      <path
        d='M57.7447 15.3662H55.3618C56.5952 15.3662 57.595 16.366 57.595 17.5994V25.2208C57.595 26.4542 56.5952 27.454 55.3618 27.454H57.7447C58.9781 27.454 59.9779 26.4542 59.9779 25.2208V17.5994C59.9778 16.366 58.978 15.3662 57.7447 15.3662Z'
        fill='#DFEAEF'
      />
      <path
        d='M61.0861 20.5894H17.043C16.6384 20.5894 16.3105 20.2615 16.3105 19.8569C16.3105 19.4523 16.6384 19.1245 17.043 19.1245H61.0861C61.4907 19.1245 61.8186 19.4523 61.8186 19.8569C61.8186 20.2615 61.4906 20.5894 61.0861 20.5894Z'
        fill='#DFEAEF'
      />
      <path
        d='M55.6656 31.5427H45.1636C44.779 31.5427 44.4673 31.231 44.4673 30.8464V27.4539H56.3619V30.8464C56.3619 31.231 56.0502 31.5427 55.6656 31.5427Z'
        fill='#98B9D3'
      />
      <path
        d='M54.3325 27.4539V30.8464C54.3325 31.231 54.0208 31.5427 53.6362 31.5427H55.6657C56.0503 31.5427 56.362 31.231 56.362 30.8464V27.4539H54.3325Z'
        fill='#81A7C6'
      />
      <path
        d='M54.3327 31.5427H46.4971L47.5962 34.0603C47.7674 34.4525 48.2232 34.7145 48.7344 34.7145H52.0955C52.6066 34.7145 53.0624 34.4525 53.2337 34.0603L54.3327 31.5427Z'
        fill='#365E7D'
      />
      <path
        d='M52.3032 31.5427L51.2041 34.0602C51.0329 34.4524 50.5771 34.7144 50.0659 34.7144H52.0954C52.6065 34.7144 53.0623 34.4524 53.2336 34.0602L54.3327 31.5427H52.3032Z'
        fill='#2B4D66'
      />
      <path
        d='M64.4102 64.6338H15.875C15.4704 64.6338 15.1426 64.306 15.1426 63.9014C15.1426 63.4968 15.4704 63.1689 15.875 63.1689H64.4102C64.8147 63.1689 65.1426 63.4968 65.1426 63.9014C65.1426 64.306 64.8147 64.6338 64.4102 64.6338Z'
        fill='#2B4D66'
      />
      <path
        d='M37.0459 25.0786C36.6413 25.0786 36.3135 24.7508 36.3135 24.3462V22.978C36.3135 22.5734 36.6413 22.2456 37.0459 22.2456C37.4505 22.2456 37.7783 22.5734 37.7783 22.978V24.3463C37.7783 24.7508 37.4505 25.0786 37.0459 25.0786Z'
        fill='#2B4D66'
      />
      <path
        d='M40.5801 25.0786C40.1755 25.0786 39.8477 24.7508 39.8477 24.3462V22.978C39.8477 22.5734 40.1755 22.2456 40.5801 22.2456C40.9847 22.2456 41.3125 22.5734 41.3125 22.978V24.3463C41.3125 24.7508 40.9847 25.0786 40.5801 25.0786Z'
        fill='#2B4D66'
      />
      <path
        d='M44.1143 25.0786C43.7097 25.0786 43.3818 24.7508 43.3818 24.3462V22.978C43.3818 22.5734 43.7097 22.2456 44.1143 22.2456C44.5188 22.2456 44.8467 22.5734 44.8467 22.978V24.3463C44.8467 24.7508 44.5188 25.0786 44.1143 25.0786Z'
        fill='#2B4D66'
      />
      <path
        d='M39.1368 58.5605H37.0459C36.6413 58.5605 36.3135 58.2327 36.3135 57.8281C36.3135 57.4235 36.6413 57.0957 37.0459 57.0957H39.1368C39.5414 57.0957 39.8692 57.4235 39.8692 57.8281C39.8692 58.2327 39.5414 58.5605 39.1368 58.5605Z'
        fill='#80B4FB'
      />
      <path
        d='M44.0523 58.5605H41.9614C41.5568 58.5605 41.229 58.2327 41.229 57.8281C41.229 57.4235 41.5568 57.0957 41.9614 57.0957H44.0523C44.4569 57.0957 44.7848 57.4235 44.7848 57.8281C44.7848 58.2327 44.4569 58.5605 44.0523 58.5605Z'
        fill='#80B4FB'
      />
      <path
        d='M48.9679 58.5605H46.877C46.4724 58.5605 46.1445 58.2327 46.1445 57.8281C46.1445 57.4235 46.4724 57.0957 46.877 57.0957H48.9679C49.3725 57.0957 49.7003 57.4235 49.7003 57.8281C49.7003 58.2327 49.3725 58.5605 48.9679 58.5605Z'
        fill='#80B4FB'
      />
      <path
        d='M52.2075 59.9415C51.8029 59.9415 51.4751 59.6136 51.4751 59.209V57.8279C51.4751 57.4233 51.8029 57.0955 52.2075 57.0955C52.6121 57.0955 52.9399 57.4233 52.9399 57.8279V59.209C52.9399 59.6136 52.612 59.9415 52.2075 59.9415Z'
        fill='#2B4D66'
      />
      <path
        d='M54.7056 59.9415C54.301 59.9415 53.9731 59.6136 53.9731 59.209V57.8279C53.9731 57.4233 54.301 57.0955 54.7056 57.0955C55.1102 57.0955 55.438 57.4233 55.438 57.8279V59.209C55.438 59.6136 55.1102 59.9415 54.7056 59.9415Z'
        fill='#2B4D66'
      />
      <path
        d='M57.2036 59.9415C56.799 59.9415 56.4712 59.6136 56.4712 59.209V57.8279C56.4712 57.4233 56.799 57.0955 57.2036 57.0955C57.6082 57.0955 57.936 57.4233 57.936 57.8279V59.209C57.936 59.6136 57.6082 59.9415 57.2036 59.9415Z'
        fill='#2B4D66'
      />
      <path
        d='M32.5824 38.3911H17.8563C17.4071 38.3911 17.043 38.0269 17.043 37.5777V34.0485C17.043 33.5993 17.4071 33.2351 17.8563 33.2351H32.5824C33.0316 33.2351 33.3958 33.5993 33.3958 34.0485V37.5777C33.3958 38.0269 33.0316 38.3911 32.5824 38.3911Z'
        fill='#80B4FB'
      />
      <path
        d='M32.5823 33.2349H30.7114C31.1606 33.2349 31.5248 33.599 31.5248 34.0482V37.5774C31.5248 38.0267 31.1606 38.3908 30.7114 38.3908H32.5823C33.0315 38.3908 33.3957 38.0267 33.3957 37.5774V34.0482C33.3958 33.599 33.0315 33.2349 32.5823 33.2349Z'
        fill='#61A2F9'
      />
      <path
        d='M48.9257 34.7146H51.9042L53.9284 42.4381C54.0025 42.7211 53.7891 42.9978 53.4966 42.9978H47.3334C47.0408 42.9978 46.8273 42.7211 46.9016 42.4381L48.9257 34.7146Z'
        fill='#80B4FB'
      />
      <path
        d='M51.9041 34.7146H50.2349L52.4057 42.9977H53.4964C53.789 42.9977 54.0024 42.721 53.9282 42.438L51.9041 34.7146Z'
        fill='#61A2F9'
      />
    </g>
    <defs>
      <clipPath id='clip0_414_9323'>
        <rect width='50' height='50' fill='white' transform='translate(15.1426 15)' />
      </clipPath>
    </defs>
  </svg>
));
RadiotherapyIcon.displayName = 'RadiotherapyIcon';

export default RadiotherapyIcon;
